import type Product from "@/queries/models/Product"

const isAllowedByCart = (
  product: Product,
  isSeasonProductInCart: boolean
): boolean => {
  if (isSeasonProductInCart)
    return product.isSeasonPass && !product.isSubscriptionProduct
  return !product.isSeasonPass && !product.isSubscriptionProduct
}

const isAllowedBySession = (
  product: Product,
  hasSelectedSubscriptionProducts: boolean
): boolean => {
  if (hasSelectedSubscriptionProducts) return product.isSubscriptionProduct
  return !product.isSubscriptionProduct
}

export { isAllowedByCart, isAllowedBySession }
